import { Box, Tooltip, Typography } from '@mui/material'
import { CheckCircle, Schedule, Error as ErrorIcon } from '@mui/icons-material'
import { freshness } from '../../theme/tokens'

const ICONS = {
  fresh: CheckCircle,
  aging: Schedule,
  stale: ErrorIcon,
}

const DEFAULT_SOURCES = [
  { name: 'Inventory', state: 'fresh', age: '—' },
  { name: 'Forecast', state: 'aging', age: '—' },
  { name: 'Master Data', state: 'aging', age: '—' },
]

function getSafeConfig(state) {
  return freshness[state] || freshness.aging || { color: '#B45309', label: '?' }
}

function getSafeIcon(state) {
  return ICONS[state] || Schedule
}

export default function FreshnessIndicator({ compact = false, sources = null }) {
  const items = Array.isArray(sources) && sources.length > 0 ? sources : DEFAULT_SOURCES

  if (compact) {
    const worst = items.reduce((w, s) => {
      const order = { fresh: 0, aging: 1, stale: 2 }
      return (order[s.state] || 0) > (order[w.state] || 0) ? s : w
    }, items[0])

    const Icon = getSafeIcon(worst.state)
    const cfg = getSafeConfig(worst.state)

    return (
      <Tooltip title={items.map(s => `${s.name}: ${s.age || '—'}`).join(' | ')}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Icon sx={{ fontSize: 18, color: cfg.color }} />
          <Typography variant="caption" sx={{ color: cfg.color }}>
            {cfg.label}
          </Typography>
        </Box>
      </Tooltip>
    )
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {items.map(source => {
        const Icon = getSafeIcon(source.state)
        const cfg = getSafeConfig(source.state)
        return (
          <Box key={source.name} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Icon sx={{ fontSize: 18, color: cfg.color }} />
            <Typography variant="body2" sx={{ flex: 1 }}>{source.name}</Typography>
            <Typography variant="caption" sx={{ color: cfg.color }}>{source.age || '—'}</Typography>
          </Box>
        )
      })}
    </Box>
  )
}
